import React, { useState } from "react";
import { Popup, Button } from "semantic-ui-react";
import { isFunction } from "lodash";
import { Confirm } from "./Confirm";

export const SafeButton = ({
  submitAction,
  confirmMsg=null,
  submitText="Delete",
  widths= "1",
  negativeAction=false,
  disabled = false,
  color = "red",
  style = {}
}) => {

  const [currentState, setCurrentState] = useState(false);
  const handleConfirm = () => {
    submitAction();
    setCurrentState(false);
  };
  const getConfirmMsg = () => {
    if (isFunction(confirmMsg))
      return confirmMsg();
    return confirmMsg;
  };

  return (
    <Popup
        content={
            <Confirm
                confirmMsg={getConfirmMsg()}
                handleConfirm={handleConfirm}
                handleDeny={() => setCurrentState(false)}
                style={{display: currentState ? "default" : "none"}}
            />
        }
        on='click'
        pinned
        open={currentState}
        onOpen={() => setCurrentState(true)}
        trigger={<Button content={submitText} color={color ? color : ""} style={style}
    />
    }
  />
  );
};
